import { useContext } from "react";
import { AuthContext } from "@/lib/context/auth";

export const useAuth = () => useContext(AuthContext);
